import { render } from "./NotificationBell.vue?vue&type=template&id=0fedcdfc"
import script from "./NotificationBell.vue?vue&type=script&lang=js"
export * from "./NotificationBell.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__